import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSidebar } from '../../contexts/SidebarContext';
import styles from './TrialBanner.module.css';

interface TrialBannerProps {
  trialDaysRemaining: number;
  trialEndDate?: string | null;
  onUpgradeClick?: () => void;
}

const TrialBanner: React.FC<TrialBannerProps> = ({ 
  trialDaysRemaining, 
  trialEndDate,
  onUpgradeClick 
}) => {
  const navigate = useNavigate();
  const { isOpen } = useSidebar();

  const handleUpgradeClick = () => {
    if (onUpgradeClick) {
      onUpgradeClick();
    } else {
      // Navigate to upgrade/payment page
      navigate('/Subscription');
    }
  };

  // Determine urgency level
  const getUrgencyClass = () => {
    if (trialDaysRemaining <= 1) return styles.critical;
    if (trialDaysRemaining <= 3) return styles.warning;
    return styles.info;
  };

  // Determine sidebar state class
  const getSidebarClass = () => {
    if (isOpen === false) return styles.sidebarCollapsed;
    if (isOpen === null) return styles.sidebarHidden;
    return ''; // Default expanded state
  };

  const getMessage = () => {
    if (trialDaysRemaining === 0) {
      return 'Your trial ends today!';
    } else if (trialDaysRemaining === 1) {
      return 'Your trial ends tomorrow!';
    } else {
      return `${trialDaysRemaining} days left in your free trial`;
    }
  };

  return (
    <div className={`${styles.trialBanner} ${getUrgencyClass()} ${getSidebarClass()}`}>
      <div className={styles.content}>
        <div className={styles.iconAndText}>
          <span className={styles.icon}>🎁</span>
          <div className={styles.textContent}>
            <div className={styles.message}>{getMessage()}</div>
            <div className={styles.subMessage}>
              Upgrade now to continue enjoying all features
            </div>
          </div>
        </div>
        <button 
          className={styles.upgradeButton}
          onClick={handleUpgradeClick}
        >
          Upgrade Now
        </button>
      </div>
    </div>
  );
};

export default TrialBanner;
